const TRUSTPILOT_THRESHOLD = 4.0;

export const hasEnoughTrustpilotStars = (stars: number | null) =>
  !!stars && stars >= TRUSTPILOT_THRESHOLD;
